function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgPrescriptionManage = function SvgPrescriptionManage(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), /*#__PURE__*/React.createElement(Path, {
    stroke: props.fillLine,
    strokeMiterlimit: 10,
    d: "m15.667 8.516.424-.424a3.147 3.147 0 0 0-4.45-4.45l-3.71 3.71-3.71 3.71a3.144 3.144 0 0 0 0 4.45 3.146 3.146 0 0 0 4.45 0l.71-.71"
  }), /*#__PURE__*/React.createElement(Path, {
    stroke: props.fillLine,
    strokeMiterlimit: 10,
    d: "M13.584 16.434a3.714 3.714 0 1 0 0-7.429 3.714 3.714 0 0 0 0 7.429ZM7.931 7.353l2.224 2.224M13.585 10.295v4.85M16.009 12.72h-4.85"
  }));
};
export default SvgPrescriptionManage;